import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHouse = () => {
  return (
    <g>
      <path d="m15.7173 7.4534-7.2227-6.3179a.7515.7515 0 0 0 -.9883 0l-3.8154 3.337v-2.0225h1.0117a.75.75 0 0 0 0-1.5h-1.7617a.75.75 0 0 0 -.75.75v4.0844l-1.9082 1.669a.75.75 0 0 0 .9883 1.1289l.92-.8046v6.5223a.75.75 0 0 0 .75.75h10.1181a.75.75 0 0 0 .75-.75v-6.5224l.92.8047a.75.75 0 0 0 .9883-1.1289zm-6.7803 6.0966h-1.873v-4.7822h1.873zm3.3721 0h-1.8721v-5.5322a.75.75 0 0 0 -.75-.75h-3.373a.75.75 0 0 0 -.75.75v5.5322h-1.8731v-7.0842l4.3091-3.7693 4.3086 3.7689z" />
    </g>
  );
};

export default withIcon(IconHouse);
